// Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Components
import { HomeComponent } from './components/home/home.component';
import { ReferencesComponent } from './components/references/references.component';
import { EquipmentComponent } from './components/equipment/equipment.component';
import { ContactComponent } from './components/contact/contact.component';
import { ImportComponent } from './components/import/import.component';
import { ImportGuard } from './guards/import.guard';
import { ImprintComponent } from './components/imprint/imprint.component';


const routes: Routes = [
  {
    path: '', redirectTo: 'home', pathMatch: 'full'
  },
  {
    path: 'home', component: HomeComponent, data: { animation: 'home' }
  },
  {
    path: 'references', component: ReferencesComponent, data: { animation: 'references' }
  },
  {
    path: 'equipment', component: EquipmentComponent, data: { animation: 'equipment' }
  },
  {
    path: 'contact', component: ContactComponent, data: { animation: 'contact' }
  },
  {
    path: 'imprint', component: ImprintComponent, data: { animation: 'imprint' }
  },
  {
    path: 'import', component: ImportComponent,
    canActivate: [ImportGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class TonteppichRoutingModule { }
